module.exports = __webpack_public_path__ + "img/hgsdj.77ee4f4d.jpg";